import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { ResponseService } from '../../../../../../services/response.service';
import { HtmlService } from '../../../../../../services/html.service';
import { RepeatableRandomGeneratorService } from '../../../../../../services/repeatable-random-generator.service';
import { LoggerService } from '../../../../../../services/logger.service';
import { MyModal } from '../../../../../common/my-modal/my-modal.component';


@Component({
    selector: 'choice-interaction',
    template: require('./choice-interaction.component.html'),
})
export class ChoiceInteractionComponent implements OnInit, OnDestroy {

    @Input() interaction: PgRendererDto.InteractionDefinition;

    selectedChoices: string[];
    choiceInteraction: PgRendererDto.ChoiceInteraction;
    responsesSubscription: Subscription;

    constructor(
        private responseService: ResponseService,
        private htmlService: HtmlService,
        private repeatableRandomGeneratorService: RepeatableRandomGeneratorService,
        private loggerService: LoggerService,
        private myModal: MyModal
    ) {
    }

    ngOnInit() {
        this.selectedChoices = [];
        this.choiceInteraction = Object.assign({}, this.interaction.ChoiceInteraction);

        if (this.choiceInteraction.Shuffle == true) {
            this.choiceInteraction.SimpleChoices = this.repeatableRandomGeneratorService.randomizeArray(this.choiceInteraction.SimpleChoices);
        }
        for (let index = 0; index < this.choiceInteraction.SimpleChoices.length; index++) {
            this.choiceInteraction.SimpleChoices[index].ChoiceDisplayOrder = index + 1;
        }

        this.responsesSubscription = this.responseService.responses$
            .flatMap(r => r)
            .filter(r => r.InteractionId == this.interaction.InteractionId)
            .subscribe(response => {
                this.selectedChoices = response.Items.map(r => r.Value);
            });
    }

    ngOnDestroy() {
        if (this.responsesSubscription) {
            this.responsesSubscription.unsubscribe();
        }
    }

    setResponse(identifier: string) {
        this.loggerService.reportDebugInfo(ChoiceInteractionComponent.name, {
            name: "setResponse",
            identifier: identifier
        });

        const hasMultipleItems = this.choiceInteraction.MaxChoices > 1;
        const choice = this.interaction.ChoiceInteraction.SimpleChoices.find(x => x.Identifier == identifier);
        let choiceDisplayOrder: number = null;;
        if(choice) {
            choiceDisplayOrder = choice.ChoiceDisplayOrder;
        }
        if (hasMultipleItems) {
            if (this.selectedChoices.indexOf(identifier) >= 0) {
                this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
            } else {
                if (this.selectedChoices.length >= this.choiceInteraction.MaxChoices) {
                    this.myModal.showRegularDlg("Warning", `You may only select ${this.choiceInteraction.MaxChoices} choices. Please deselect an existing choice to continue.`);
                    return;
                }
                this.responseService.setResponse(this.interaction, null, identifier, null, true, choiceDisplayOrder);
            }
        } else {
            this.responseService.setResponse(this.interaction, null, identifier, null, false, choiceDisplayOrder);
        }
    }

    replaceImageResourcePlaceHoldersWithTags(html: string): string {
        return this.htmlService.replaceImageResourcePlaceHoldersWithTags(html);
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/choice-interaction/choice-interaction.component.ts